<mat-card class="rounded-3xl border border-slate-200 p-4 shadow-lg shadow-slate-200/60">
  <h3 class="mb-3 text-lg font-semibold text-slate-900">Affiliate assignment</h3>

  @if (!canAssign()) {
    <p class="text-sm text-slate-500">You do not have permission to assign an affiliate to this intervention.</p>
  } @else {
    <div class="flex flex-wrap items-end gap-3">
      <searchable-lookup-select
        class="min-w-64"
        [formControl]="affiliateControl"
        label="Affiliate"
        placeholder="Select affiliate"
        searchPlaceholder="Search affiliates"
        loadingLabel="Loading affiliates..."
        [options]="affiliateOptions()"
        [loading]="affiliateStore.affiliateLookupLoading()"
        (searchChanged)="affiliateSearchChanged($event)" />
      <button
        mat-flat-button
        type="button"
        [disabled]="!affiliateControl.value || interventionStore.assigningAffiliate()"
        (click)="assign()">
        @if (interventionStore.assigningAffiliate()) {
          <mat-spinner diameter="20" class="mr-2" />
        }
        Assign affiliate
      </button>
    </div>

    @if (interventionStore.currentAssignment(); as assignment) {
      <div class="mt-4 rounded-2xl border border-slate-200 p-3">
        <p class="text-sm font-semibold text-slate-900">Current assignment</p>
        <p class="text-sm text-slate-600">Status: {{ assignment.assignmentStatus }}</p>
        <p class="text-sm text-slate-600">Assigned: {{ assignment.assignedDate }}</p>
      </div>
    }
  }
</mat-card>
